<template>
    <div>
      <header-sales></header-sales>
  
      <div id= "subheader"> </div> 

      <div id= "main-container"> 
        <div id= "label-container">
          <span id="label">Descuentos</span>
        </div> 
        <div id= "container">
          <div id="list-container">
            <item-descuento id="list-prod" v-for="item in items" :item='item' ></item-descuento>
          </div>
        </div> 
      </div> 
  
    </div>
  </template>
  
  
  
  <script>

    import HeaderSales from '@components/views/header.vue';
    import ItemDescuento from '@components/views/descuentos/itemDescuento.vue';

    export default {
      name: 'Descuentos',
      components:{
       'header-sales': HeaderSales,
       'item-descuento': ItemDescuento
      },
  
      // data() {
      //    return {
      //      items:[{'Nombre':'cdcdcdcd'},{'Nombre':'cdcdcdcd'},{'Nombre':'cdcdcdcd'},{'Nombre':'cdcdcdcd'},{'Nombre':'cdcdcdcd'},{'Nombre':'cdcdcdcd'},{'Nombre':'cdcdcdcd'},{'Nombre':'cdcdcdcd'},{'Nombre':'cdcdcdcd'},{'Nombre':'cdcdcdcd'},{'Nombre':'cdcdcdcd'},{'Nombre':'cdcdcdcd'},{'Nombre':'cdcdcdcd'},{'Nombre':'cdcdcdcd'},{'Nombre':'cdcdcdcd'},{'Nombre':'cdcdcdcd'},{'Nombre':'cdcdcdcd'},{'Nombre':'cdcdcdcd'}],
      //    }
      // },

      computed: {
  
        items () {
          return this.$store.state.pedido.descuentos;
        },
      },

      mounted: function () {
        this.$store.commit('loader/stop')
      }

    }
    
  </script>
  
  
<style scoped>
   
  #subheader {
   width: 100%;
   height: 35vh;
   background: linear-gradient(#005A9F , #1899D6);
  }

  #main-container{
   position: absolute;
   top: 55vh;
   left: 50%;
   transform: translate(-50%,-50%);
   width: 700px;
   height: 85vh;
  }

  #label-container{
   width: 700px;
   height: 10vh;
  }

  #label{
   color:#ffffff;
   font-size: 27px;
  }

  #container{
   width: 700px;
   height: 75vh;
   padding-top: 30px;
   border-width: 1px;
   border: 1px solid #dddddd;
   box-sizing: border-box;
   /*box-shadow: 3px 3px 4px #dddddd;*/
   background-color: #ffffff;
  }

  #list-container{
   width: 660px;  
   height: 65vh;
   margin-left: auto;
   margin-right: auto;
   background: #ffffff;
   overflow: auto;
   display: flex;
   flex-direction:column; 
   align-items: center; 
  }


/* width */
::-webkit-scrollbar {
    width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #dddddd; 
    border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
    background: #cccccc; 
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #bbbbbb; 
}


  </style>


// WEBPACK FOOTER //
// src/components/views/descuentos/descuentos.vue